import { VFC } from "react";

import { Box, useTheme } from "@portex-pro/ui-components";
import compact from "lodash/compact";
import { DateTime } from "luxon";

import { Lane, ShipperLaneAward } from "../types";
import MultiStopTooltipView from "./MultiStopTooltipView";
import TextTableCellWithSkeletonView from "./TextTableCellWithSkeletonView";

const StopContainer: VFC<{ laneOrAward: Lane | ShipperLaneAward; index: number }> = ({ laneOrAward, index }) => {
  const theme = useTheme();
  const isPickup = index === 0;
  const stop = laneOrAward.lane_stops[index];

  const title = `${stop.name ?? ""}`;
  const description = (
    <Box display="flex" gridGap={theme.spacing(1)}>
      <div className="flex flex-col">
        {compact([stop.street_address, stop.city, stop.state_code]).filter(Boolean).join(", ")}
        {stop.appointment_start &&
          ` (${[stop.appointment_start, stop.appointment_end]
            .filter(Boolean)
            .map((time) =>
              time
                ? DateTime.fromObject(time as { hour: number; minute: number }).toLocaleString(DateTime.TIME_SIMPLE)
                : ""
            )
            .join(" - ")})`}
      </div>
      {isPickup && (
        <MultiStopTooltipView
          allStops={laneOrAward.lane_stops.map((stop) => ({
            name: stop.name,
            streetAddress: stop.street_address,
            city: stop.city,
            provinceCode: stop.state_code,
            date: stop.date,
          }))}
        />
      )}
    </Box>
  );

  return <TextTableCellWithSkeletonView title={title} description={description} />;
};

export default StopContainer;
